export default __webpack_public_path__ + "static/media/person.d6379c56.svg";